var _style, _defs, _defs2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99 100",
    style: {
      enableBackground: "new 0 0 99 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{clip-path:url(#SVGID_4_);fill:#D1D5D6;}\r\n\t.st2{clip-path:url(#SVGID_4_);fill:#C9C9C9;}\r\n\t.st3{clip-path:url(#SVGID_4_);fill:#183962;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Barcode_1_"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.6,
    y: 9.8,
    width: 97.8,
    height: 81.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 0.6,
    y: 9.8,
    width: 97.8,
    height: 81.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.3,14.7H0.6V9.8h18.7c1.3,0,2.4,1.1,2.4,2.4C21.8,13.6,20.7,14.7,19.3,14.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.6,28.6V9.8h4.9v18.7c0,1.4-1.1,2.4-2.4,2.4C1.7,31,0.6,29.9,0.6,28.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3,31L3,31c-1.4,0-2.4-1.1-2.4-2.4V9.8h1.9l0,17.8C2.5,27.6,2.5,29.2,3,31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.5,28.6V9.8h4.9v18.7c0,1.4-1.1,2.4-2.4,2.4C94.6,31,93.5,29.9,93.5,28.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.7,9.8h18.7v4.9H79.7c-1.4,0-2.4-1.1-2.4-2.4C77.2,10.9,78.3,9.8,79.7,9.8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.5,9.8c-1.4,0-2.4,1.1-2.4,2.4c0,1.4,1.1,2.4,2.4,2.4h-2.9c-1.4,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4 h2.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.7,86.8h18.7v4.9H79.7c-1.4,0-2.4-1.1-2.4-2.4C77.2,87.9,78.3,86.8,79.7,86.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.4,72.9v18.7h-4.9V72.9c0-1.4,1.1-2.4,2.4-2.4C97.3,70.5,98.4,71.6,98.4,72.9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.5,72.9v18.7H0.6V72.9c0-1.4,1.1-2.4,2.4-2.4C4.4,70.5,5.5,71.6,5.5,72.9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.3,91.7H0.6v-4.9h18.7c1.3,0,2.4,1.1,2.4,2.4C21.8,90.6,20.7,91.7,19.3,91.7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3,70.5L3,70.5c-1.4,0-2.4,1.1-2.4,2.4v18.7h1.9l0-17.8C2.5,73.8,2.5,72.3,3,70.5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.5,86.8c-1.4,0-2.4,1.1-2.4,2.4c0,1.4,1.1,2.4,2.4,2.4h-2.9c-1.4,0-2.4-1.1-2.4-2.4 c0-1.3,1.1-2.4,2.4-2.4h2.5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.2,72.6h-0.8c-2.1,0-3.8-1.7-3.8-3.8V35.6c0-2.1,1.7-3.8,3.8-3.8h0.8c2.1,0,3.8,1.7,3.8,3.8v33.2 C26,70.9,24.3,72.6,22.2,72.6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71,72.6L71,72.6c-2.4,0-4.3-1.9-4.3-4.3V36.2c0-2.4,1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3v32.2 C75.2,70.7,73.3,72.6,71,72.6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.4,72.6L37.4,72.6c-1.8,0-3.3-1.5-3.3-3.3V35.1c0-1.8,1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3v34.2 C40.6,71.2,39.2,72.6,37.4,72.6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30,72.6L30,72.6c-1.4,0-2.4-1.1-2.4-2.4V34.3c0-1.3,1.1-2.4,2.4-2.4c1.4,0,2.4,1.1,2.4,2.4v35.9 C32.5,71.5,31.4,72.6,30,72.6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.3,72.6L55.3,72.6c-1.8,0-3.3-1.5-3.3-3.3V35.1c0-1.8,1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3v34.2 C58.5,71.2,57.1,72.6,55.3,72.6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48,72.6L48,72.6c-1.4,0-2.4-1.1-2.4-2.4V34.3c0-1.3,1.1-2.4,2.4-2.4s2.4,1.1,2.4,2.4v35.9 C50.4,71.5,49.3,72.6,48,72.6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M61,72.6L61,72.6c-0.5,0-0.8-0.4-0.8-0.8V32.7c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v39.1 C61.8,72.3,61.4,72.6,61,72.6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M80.6,72.6L80.6,72.6c-0.5,0-0.8-0.4-0.8-0.8V32.7c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8v39.1 C81.4,72.3,81,72.6,80.6,72.6"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanner);
export default __webpack_public_path__ + "static/media/scanner.a3063c075365698756d9379c9641e889.svg";
export { ForwardRef as ReactComponent };